import React, { FC } from 'react'

import { IconVSimAndDeviceProps } from './IconVSimAndDevice.types'
import * as Styled from './styles/IconVSimAndDevice.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVSimAndDevice: FC<IconVSimAndDeviceProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVSimAndDeviceProps['size'],
  isResponsive = false,
}: IconVSimAndDeviceProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M27.773 34.547c-.57.3-1.207.453-1.851.453h-14a4 4 0 0 1-4-4V17a4 4 0 0 1 4-4H27.25a2.673 2.673 0 0 1 2.672 2.672v6.39'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='m12.922 13 .883-7.063A1.071 1.071 0 0 1 14.867 5h8.11c.539 0 .996.402 1.062.938L24.922 13m0 22.07-.883 7.063a1.071 1.071 0 0 1-1.062.937h-8.11a1.07 1.07 0 0 1-1.062-.937l-.883-7.063'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M27.773 40.668V24.465a2.403 2.403 0 0 1 2.403-2.402h5.933L40 25.843v14.825a2.406 2.406 0 0 1-2.402 2.402h-7.422a2.403 2.403 0 0 1-2.403-2.402Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M32.36 31.21h3.054c.563 0 1.02.458 1.02 1.02v6.118a1.02 1.02 0 0 1-1.02 1.02H32.36a1.021 1.021 0 0 1-1.023-1.02V32.23c0-.563.457-1.02 1.023-1.02Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconVSimAndDevice
